// 宠物选择活动页面交互功能

class PetSelectionActivity {
  constructor() {
    this.selectedPet = null;
    this.init();
  }

  // 初始化功能
  init() {
    // 页面加载完成后初始化
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.bindEvents();
      });
    } else {
      this.bindEvents();
    }
  }

  // 绑定事件
  bindEvents() {
    // 监听页面切换
    window.showPage = (pageNumber) => this.showPage(pageNumber);
    window.selectPet = (element, petData) => this.selectPet(element, petData);
  }

  // 显示指定页面
  showPage(pageNumber) {
    // 隐藏所有页面
    const pages = document.querySelectorAll('.activity-page');
    pages.forEach(page => {
      page.classList.add('hidden');
    });

    // 显示指定页面
    const targetPage = document.getElementById(`page-${pageNumber}`);
    if (targetPage) {
      targetPage.classList.remove('hidden');
    }

    // 如果显示第3页且有选中的宠物，更新页面内容
    if (pageNumber === 3 && this.selectedPet) {
      this.updatePage3Content();
    }
  }

  // 选择宠物
  selectPet(element, petData) {
    // 移除其他宠物的选中状态
    const allCards = document.querySelectorAll('.pet-card');
    allCards.forEach(card => {
      card.classList.remove('selected');
    });

    // 选中当前宠物
    element.classList.add('selected');
    this.selectedPet = petData;

    // 启用下一步按钮
    const nextButton = document.querySelector('.next-button');
    if (nextButton) {
      nextButton.disabled = false;
    }

    console.log('已选择宠物:', petData);
  }

  // 更新第3页内容
  updatePage3Content() {
    if (!this.selectedPet) return;

    const petData = this.selectedPet;
    
    // 更新奖项标题
    const awardTitle = document.querySelector('.award-title');
    if (awardTitle) {
      awardTitle.textContent = `Most Popular ${petData.name} Award`;
    }

    // 更新选中宠物的图片
    const selectedPetImage = document.querySelector('.selected-pet-image');
    if (selectedPetImage && petData.image) {
      selectedPetImage.src = petData.image;
      selectedPetImage.alt = petData.name;
    }

 
    
    const funFactContent = document.querySelector('#fun-fact-content');
    if (funFactContent) {
      funFactContent.textContent = petData.funFactContent || 'No fun fact available.';
    }

    
    const careTipContent = document.querySelector('#care-tip-content');
    if (careTipContent) {
      careTipContent.textContent = petData.careTipContent || 'No care tip available.';
    }
  }

  // 获取选中的宠物
  getSelectedPet() {
    return this.selectedPet;
  }
}

// 创建实例
const petActivity = new PetSelectionActivity();